import { Box, Toolbar, OutlinedInput, InputAdornment, IconButton } from '@mui/material';
import { Iconify } from 'src/components/iconify';

interface CompanyTableToolbarProps {
  numSelected: number;
  filterName: string;
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch?: () => void;
}

export function CompanyTableToolbar({
  numSelected,
  filterName,
  onFilterName,
  onClearSearch,
}: CompanyTableToolbarProps) {
  return (
    <Toolbar
      sx={{
        height: 96,
        display: 'flex',
        justifyContent: 'space-between',
        p: (theme) => theme.spacing(0, 1, 0, 3),
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Box component="span" sx={{ flexGrow: 1 }}>
          {numSelected} seçildi
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                     <OutlinedInput
             value={filterName}
             onChange={onFilterName}
             placeholder="Şirket ara... (Gerçek zamanlı filtreleme)"
             startAdornment={
               <InputAdornment position="start">
                 <Iconify
                   icon="eva:search-fill"
                   sx={{ color: 'text.disabled', width: 20, height: 20 }}
                 />
               </InputAdornment>
             }
           />
          
          {filterName && onClearSearch && (
            <IconButton
              onClick={onClearSearch}
              sx={{ 
                bgcolor: 'error.main', 
                color: 'white',
                '&:hover': { bgcolor: 'error.dark' }
              }}
            >
              <Iconify icon="eva:close-fill" />
            </IconButton>
          )}
        </Box>
      )}
    </Toolbar>
  );
} 